import React from "react";
import AboutSection from "../home/ui/AboutSection";
import usePageMetadata from "@/lib/usePageMetadata";
import Features from "./ui/FeaturesSection";

function About() {
  usePageMetadata(
    "About | BioStat",
    "Learn more about BioStat and our mission to support medical research.",
  );

  return (
    <div>
      <AboutSection />
      <Features />
    </div>
  );
}

export default About;
